import CapitalGainAmountError from './CapitalGainAmountError';
import CapitalGainCrowdfundingPropertyNotFound from './CapitalGainCrowdfundingPropertyNotFound';
import CapitalGainInvalidCrowdfundingPropertyID from './CapitalGainInvalidCrowdfundingPropertyID';
import InvalidCapitalGainAmount from './InvalidCapitalGainAmount';
import TargetCapitalGainNotReachable from './TargetCapitalGainNotReachable';
import CapitalGainAmount from './CapitalGainAmount';
export default CapitalGainAmount;
export { CapitalGainAmountError, CapitalGainCrowdfundingPropertyNotFound, CapitalGainInvalidCrowdfundingPropertyID, InvalidCapitalGainAmount, TargetCapitalGainNotReachable };
